import { createApiClient } from '@next-qr/lib-ui/api';

const API_BASE = import.meta.env.VITE_API_URL || '';

export const userApi = createApiClient({
  baseUrl: `${API_BASE}/api/user`,
});
